// @flow
import ProfilePageRoot from './ProfilePageRoot';

export default ProfilePageRoot;
